$(document).ready(function() {


    // #############################################
    //Form Validation :::
    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {
                error.appendTo(element.parents('.form-field'));
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });


    // #############################################
    //Custom Select Dropdown && Multiselect :::
    //$('.custom-select-dropdown').SumoSelect();

    // reload native select after changing option
    $('.SumoSelect .optWrapper li').click(function(event) {
        event.stopPropagation();
        $('select.custom-select-dropdown')[0].sumo.reload();
    });


    // #############################################
    //Lightbox Initiations ::::
    $('.open-popup-link').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        midClick: true
    });

    $('.open-popup-iframe').magnificPopup({
        type:'iframe',
        showCloseBtn: true,
        closeOnBgClick: true,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        midClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // #############################################
    // TABS

    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();

        var key = $(this).attr('data-key');
        var url = $(this).attr('data-src');

        $('.js-header-tab-urls').each(function (index) {
        	$(this).attr('href', url + '/' + $(this).attr('data-slug') + '?species=' + key);
        });
    });

    // #############################################
    //Dropdowns

    $('.js-toggle-products').on('click', function() {
        $('.products-dropdown').slideToggle(150);
        $('.diseasses-dropdown').slideUp(0);
        $('.resources-dropdown').slideUp(0);

        var selected = $(this).find('a').hasClass('selected');

        if(!selected) {
            console.log('products');
            hj('trigger', 'products');
        }

        $(this).find('a').toggleClass('selected');
        $(this).find('span').toggleClass('selected');

        $('.js-toggle-diseases, .js-toggle-resources').find('.selected').removeClass('selected');
        $("body").removeClass('open-menu');

        $(".site-header").toggleClass('dark-menu');

    });

    $('.js-toggle-diseases').on('click', function() {
       $('.diseasses-dropdown').slideToggle(150);
       $('.products-dropdown').slideUp(0);
       $('.resources-dropdown').slideUp(0);

       var selected = $(this).find('a').hasClass('selected');
        if(!selected) {
            console.log('diseases')
            hj('trigger', 'diseases');
        }

       $(this).find('a').toggleClass('selected');
       $(this).find('span').toggleClass('selected');

       $('.js-toggle-products, .js-toggle-resources').find('.selected').removeClass('selected');
       $("body").removeClass('open-menu');

       if ($('.site-header').not('.dark-menu')){
            console.log('test');
           $(".site-header").toggleClass('dark-menu');
       }
    });

    $('.js-toggle-search').on('click', function() {
       $('.search-dropdown').slideToggle(150);
       $('.products-dropdown, .diseasses-dropdown, .resources-dropdown').slideUp(0);
       $(this).find('a').toggleClass('selected');
       $("body").removeClass('open-menu');
        if ($('.site-header').not('.dark-menu')){
            console.log('test');
            $(".site-header").toggleClass('dark-menu');
        }
       $(".js-toggle-search-desktop").toggleClass('active');
    });

    $('.js-toggle-resources').on('click', function() {
        $('.resources-dropdown').slideToggle(150);
        $('.diseasses-dropdown').slideUp(0);
        $('.products-dropdown').slideUp(0);

        var selected = $(this).find('a').hasClass('selected');
        if(!selected) {
            hj('trigger', 'resources');
        }

        $(this).find('a').toggleClass('selected');
        $(this).find('span').toggleClass('selected');

        $('.js-toggle-products, .js-toggle-diseases').find('.selected').removeClass('selected');
        $("body").removeClass('open-menu');

        $(".site-header").toggleClass('dark-menu');
    });



    $('.js-filter-species').click(function() {
    	$('.js-filter-species').removeClass('active');
    	$(this).addClass('active');
    	$('.js-input-species').val($(this).attr('data-key'));
    });

});


$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};


// #############################################
//Main Menu :::
function slideMenu(action){
    var $menu = $('#mobile-menu')
    if (!action) { toggle(); return }
    if (action == "open") { open(); return }
    if (action == "close") { close(); return }

    function open(){
        $("body").addClass('open-menu');
        $menu.attr('status', 'open');
    }
    function close(){
        $("body").removeClass('open-menu');
        $menu.attr('status', 'closed');
    }
    function toggle(){
        var status =  $menu.attr('status');
        if (status == "open"){ close(); return }
        if (status == "closed"){ open(); return }
    }
}

$('#mobile-menu li').each(function(){
        $(this).has("ul").addClass('mobile-menu-parent');
});

$( ".mobile-menu-parent .icon" ).on("click", function(){
    $(this).siblings('ul').slideToggle(150);
});

//prevent slide up
$(".mobile-menu-parent").on("click", "ul", function(event){
    event.stopPropagation()
})

// #############################################
// Header Highlighter :::

$(document).ready(function() {
    var headerHref = "#site-header";
    var mobileHref = "#mobile-menu";
    var myURL = "/" + location.pathname.split('/')[1];

    $(headerHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })

    $(mobileHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })
});



